<template>
  <div :class="['product-center', {'is-flag': $flag}]">
    <div class="top-banner" :style="{ backgroundImage: 'url(' + bannerUrl + ')' }">
      <div class="banner-content">
        <h1>产品中心</h1>
        <p>提供最前沿的医疗影像数字化解决方案</p>
      </div>
    </div>

    <div class="product-main container">
      <!-- Product Type Navigation -->
      <div class="type-nav">
        <div
          v-for="item in typeList"
          :key="item.id"
          class="nav-card"
          :class="{ 'active': num === item.id }"
          @click="changeOne(item.id)"
        >
          <img :src="item.url" :alt="item.title" />
          <div class="nav-title">{{ item.title }}</div>
        </div>
      </div>

      <!-- Product Tabs -->
      <div class="product-content-tabs">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <template v-if="num === 1">
            <el-tab-pane label="云影后台系统" name="first">
              <div class="item-box">
                <div class="item-visual">
                  <div class="carousel-wrapper">
                    <div class="jt left-jt" @click="prevSlide">
                      <img src="../assets/imgs/left.png" alt="Prev">
                    </div>
                    <el-carousel :interval="4000" arrow="never" indicator-position="none" ref="carousel">
                      <el-carousel-item v-for="item in imgurl" :key="item.id">
                        <img class="banner-img" :src="item.url" alt="" />
                      </el-carousel-item>
                    </el-carousel>
                    <div class="jt right-jt" @click="nextSlide">
                      <img src="../assets/imgs/right.png" alt="Next">
                    </div>
                  </div>
                </div>
                <div class="item-info">
                  <span class="info-tag">Product Detail</span>
                  <h2 class="info-title">云影像应用平台</h2>
                  <p class="info-desc">医学云影像服务作为云端系统，主要用于医学机构、学术组织及医院间的存储、共享以及医学图像的处理。它可以让用户获取医学影像数据、加强医疗机构间的协作、共享患者的医学影像检查结果。</p>
                  <el-button type="primary" size="medium">立即咨询</el-button>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane label="云影小程序" name="second">
              <div class="item-box">
                <div class="item-visual">
                  <img class="phone-mockup" src="../assets/imgs/phone.png" alt="Cloud Image Applet" />
                </div>
                <div class="item-info">
                  <span class="info-tag">Mobile Solution</span>
                  <h2 class="info-title">云影像小程序</h2>
                  <p class="info-desc">患者在做X线检查、CT、磁共振等影像检查后，可通过二维码扫描在手机、iPad、电脑等终端，随时随地查看、下载或分享影像数据。医生能够快速在终端上，随时随地查看患者的的影像、书写报告、审核报告、速调阅患者的历史检查。</p>
                  <el-button type="primary" size="medium">立即体验</el-button>
                </div>
              </div>
            </el-tab-pane>
          </template>

          <template v-if="num === 2">
            <el-tab-pane label="SAAS运营后台" name="first">
              <div class="item-box">
                <div class="item-visual">
                  <div class="carousel-wrapper">
                    <div class="jt left-jt" @click="prevSlide">
                      <img src="../assets/imgs/left.png" alt="Prev">
                    </div>
                    <el-carousel :interval="4000" arrow="never" indicator-position="none" ref="carousel">
                      <el-carousel-item v-for="item in imgurl1" :key="item.id">
                        <img class="banner-img" :src="item.url" alt="" />
                      </el-carousel-item>
                    </el-carousel>
                    <div class="jt right-jt" @click="nextSlide">
                      <img src="../assets/imgs/right.png" alt="Next">
                    </div>
                  </div>
                </div>
                <div class="item-info">
                  <span class="info-tag">Management Tool</span>
                  <h2 class="info-title">SAAS运营后台</h2>
                  <p class="info-desc">主要面向公司和租户公司内部员工使用。Saas产品进入进攻期后，客户量增多，项目中心转移为客户成功，需要有一个运营管理后台提高运营人员的工作效率，保证客户得到的服务质量。</p>
                  <el-button type="primary" size="medium">申请演示</el-button>
                </div>
              </div>
            </el-tab-pane>
          </template>

          <template v-if="num === 3">
            <el-tab-pane label="智能AI+大数据智能诊断" name="first">
              <div class="item-box">
                <div class="item-visual">
                  <img class="phone-mockup" src="../assets/imgs/pic6.png" alt="Big Data Diagnosis" />
                </div>
                <div class="item-info">
                  <span class="info-tag">AI & Big Data</span>
                  <h2 class="info-title">大数据智能诊断平台</h2>
                  <p class="info-desc">科学地将云计算、大数据、人工智能等技术与医学影像创新融合，打造“专业影像云+人工智能应用平台”，服务医疗全场景。</p>
                  <div class="info-features">
                    <el-popover
                      v-for="item in tips"
                      :key="item.id"
                      placement="top"
                      width="240"
                      trigger="hover"
                    >
                      <div class="popover-content">{{ item.content }}</div>
                      <el-button slot="reference" class="feature-btn">{{ item.title }}</el-button>
                    </el-popover>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </template>
        </el-tabs>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProductCenter',
  data() {
    return {
      activeName: 'first',
      bannerUrl: this.$flag
        ? require('@/assets/imgs/banner2.png')
        : require('@/assets/imgs/product.png'),
      num: 1,
      imgurl: [
        { id: 1, url: require('@/assets/imgs/pic5.png') },
        { id: 2, url: require('@/assets/imgs/pic1.png') },
      ],
      imgurl1: [
        { id: 1, url: require('@/assets/imgs/pic2.png') },
        { id: 2, url: require('@/assets/imgs/pic3.png') },
      ],
      typeList: [
        {
          id: 1,
          title: '医疗影像系统',
          url: require('@/assets/imgs/icon-pro1.png'),
        },
        {
          id: 2,
          title: '企业定制服务',
          url: require('@/assets/imgs/icon-pro3.png'),
        },
        {
          id: 3,
          title: '大数据人工智能',
          url: require('@/assets/imgs/icon-pro2.png'),
        },
      ],
      tips: [
        { id: 1, title: '体质辨识', content: '辨识出患者的体质情况并给出合理的调理建议' },
        { id: 2, title: '电子病历', content: '保存病人的望闻问切信息' },
        { id: 3, title: '后台管理', content: '后台数据的维护管理' },
        { id: 4, title: '辩证论治', content: '选择疾病和病症，系统推荐处方' },
        { id: 5, title: '知识库', content: '医生学习园地' },
        { id: 6, title: '直接选方', content: '通过处方名开方' },
        { id: 7, title: '历史病例', content: '可查看历史就诊病例' },
        { id: 8, title: '协定方', content: '医生通过设置协定方开方' },
        { id: 9, title: '手动开方', content: '医生手动进行开方' },
        { id: 10, title: '专业化培训', content: '行业专家为团队 design 培训流程及内容' },
        { id: 11, title: '定制化培训', content: '根据培训学院、合作对象、培训要求等定制不同专业课程及培训流程' },
        { id: 12, title: '系统化培训', content: '全科医生成长各阶段课程及师资培训等课程呈现各学科系列化、阶段化特点' },
        { id: 13, title: '混合式培训', content: '线上培训、线下面授和线上线下相结合多种方式' },
        { id: 14, title: 'PC+移动端', content: '线上课程学习多端口进入，例如PC、APP、微信公众号等' },
      ],
    }
  },
  methods: {
    changeOne(n) {
      this.num = n
      this.activeName = 'first'
    },
    handleClick(tab) {
      console.log(tab)
    },
    prevSlide() {
      this.$refs.carousel.prev()
    },
    nextSlide() {
      this.$refs.carousel.next()
    },
  },
}
</script>

<style lang="less" scoped>
@import "../assets/css/product.less";

.popover-content {
  font-size: 14px;
  color: #424245;
  line-height: 1.6;
}
</style>
